module.exports = __webpack_public_path__ + "static/img/RAPD-1U235-B_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U235-B_1.png
// module id = heBd
// module chunks = 0